import templatePreview from "../../assets/treehouse.png";
let treehouseImg = window.wpmNotificationPluginBuildUrl + templatePreview;
const downloadId = "602";

const treehouse = [
  {
    id: "treehouse_wp-signup-admin",
    image: treehouseImg,
    label: "Treehouse",
    category: "wp-signup-admin",
    downloadId,
  },
  {
    id: "treehouse_wp-signup-user",
    image: treehouseImg,
    label: "Treehouse",
    category: "wp-signup-user",
    downloadId,
  },
  {
    id: "treehouse_wp-lost-password-admin",
    image: treehouseImg,
    label: "Treehouse",
    category: "wp-lost-password-admin",
    downloadId,
  },
  {
    id: "treehouse_wp-lost-password-user",
    image: treehouseImg,
    label: "Treehouse",
    category: "wp-lost-password-user",
    downloadId,
  },
  {
    id: "treehouse_wp-password-changed-user",
    image: treehouseImg,
    label: "Treehouse",
    category: "wp-password-changed-user",
    downloadId,
  },
  {
    id: "treehouse_wp-change-user-email-user",
    image: treehouseImg,
    label: "Treehouse",
    category: "wp-change-user-email-user",
    downloadId,
  },
  {
    id: "treehouse_wp-changed-user-email-user",
    image: treehouseImg,
    label: "Treehouse",
    category: "wp-changed-user-email-user",
    downloadId,
  },
  {
    id: "treehouse_wp-comment-in-moderation-admin",
    image: treehouseImg,
    label: "Treehouse",
    category: "wp-comment-in-moderation-admin",
    downloadId,
  },
  {
    id: "treehouse_wp-comment-published-post-author",
    image: treehouseImg,
    label: "Treehouse",
    category: "wp-comment-published-post-author",
    downloadId,
  },
  {
    id: "treehouse_wp-change-site-admin-email",
    image: treehouseImg,
    label: "Treehouse",
    category: "wp-change-site-admin-email",
    downloadId,
  },
  {
    id: "treehouse_wp-changed-site-admin-email",
    image: treehouseImg,
    label: "Treehouse",
    category: "wp-changed-site-admin-email",
    downloadId,
  },
  {
    id: "treehouse_wp-request-personal-data-user",
    image: treehouseImg,
    label: "Treehouse",
    category: "wp-request-personal-data-user",
    downloadId,
  },
  {
    id: "treehouse_wp-confirmed-personal-data-request-admin",
    image: treehouseImg,
    label: "Treehouse",
    category: "wp-confirmed-personal-data-request-admin",
    downloadId,
  },
  {
    id: "treehouse_wp-download-personal-data-user",
    image: treehouseImg,
    label: "Treehouse",
    category: "wp-download-personal-data-user",
    downloadId,
  },
  {
    id: "treehouse_wp-erased-personal-data-user",
    image: treehouseImg,
    label: "Treehouse",
    category: "wp-erased-personal-data-user",
    downloadId,
  },
];

export default treehouse;
